import React from 'react';

export default class DropDownFilter extends React.Component {
  render() {
    return (
      <div
        style={{
          marginBottom: '16px',
        }}
        className={`cps-form-group`}>
        <input
          className={`cps-form-control`}
          onChange={e => {
            this.props.setFilter(e.target.value.toLowerCase());
          }}
          placeholder={'Search a team member'}
        />
      </div>
    );
  }
}
